import i1 from "assets/images/posts/i1.jpg";
import PostImage from "./PostImage";

const PostMedia1 = () => {
    return <PostImage img={i1} className="post-image" />;
};

export default PostMedia1;
